import type { UsageItemDto } from '@saaga/billingv2-sdk'

import type { BillingUsageEntry, UsageType } from '@/components/billing/billing.interface'

const STEP_TYPE_TO_USAGE_TYPE: Record<string, UsageType> = {
  llm_call: 'llm',
  tool_call: 'tool',
}

const MICROS_PER_DOLLAR = 1_000_000

const getUsageType = (stepType?: string | null): UsageType => {
  if (!stepType) return 'other'
  return STEP_TYPE_TO_USAGE_TYPE[stepType] ?? 'other'
}

const getStepName = (item: UsageItemDto): string => {
  if (item.agentName) return item.agentName
  if (item.stepCount !== undefined) return `Step ${item.stepCount}`
  return 'Unknown Step'
}

const getResourceName = (item: UsageItemDto): string => {
  if (item.llmModel) return item.llmModel
  if (item.toolName) return item.toolName
  return 'Unknown Resource'
}

const getChatName = (conversationId?: string | null): string | undefined => {
  if (!conversationId) return undefined
  const shortId = conversationId.slice(0, 8)
  return `Chat ${shortId}...`
}

const getUserName = (clerkId?: string | null): string => {
  if (!clerkId) return 'User'
  return `User ${clerkId.slice(0, 8)}...`
}

const convertMicrosToDollars = (amountMicros: string): number => {
  const micros = Number.parseFloat(amountMicros)
  if (Number.isNaN(micros)) return 0
  return micros / MICROS_PER_DOLLAR
}

export const transformUsageItem = (item: UsageItemDto): BillingUsageEntry => ({
  id: item.id,
  createdAt: new Date(item.createdAt),
  type: getUsageType(item.stepType),
  stepName: getStepName(item),
  resourceName: getResourceName(item),
  costAmount: convertMicrosToDollars(item.amount),
  chatId: item.conversationId ?? undefined,
  chatName: getChatName(item.conversationId),
  userId: item.clerkId ?? 'unknown',
  userName: getUserName(item.clerkId),
})

export const transformUsageItemList = (itemList: UsageItemDto[]): BillingUsageEntry[] =>
  itemList.map(transformUsageItem)
